/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap';
import CommonLoader from "../../Common/CommonLoader";
import ErpApiError from "./ErpApiError";
import ErpInvoiceList from "./ErpInvoiceList";
import DeliveryNoteFrameNumber from "./DeliveryNoteFrameNumber";
import PurchaseOrderTab from "./PurchaseOrderTab";
import PurchaseReceiptTab from "./PurchaseReceiptTab";
import { useSelector, useDispatch } from "react-redux";
import { getErpOrderSyncTab } from "../../../redux/actions/adminActions";
import MaterialTransferTab from "./MaterialTransferTab";
import ErpCancelOrderTab from "./ErpCancelOrderTab";

const ERTApiFailures = (props) => {
    const [ OrderViewerModal, setOrderViewerModal ] = useState({
        open: false,
        Title: "",
        Data: {}
    });
    const Dispatch = useDispatch();
    const [ Loader, setLoader ] = useState(false);
    const { OrderSynceTab } = useSelector((state) => state.adminReducers);

    useEffect(() => {
        if(OrderSynceTab === undefined) {
            Dispatch(getErpOrderSyncTab("erp_api_error"))
        };
    }, [ OrderSynceTab ]);

    // error message modal close
    const CloseErrorMessageModal = () => {
        setOrderViewerModal({
            ...OrderViewerModal,
            open: false,
            Title: "",
            Data: {}
        });
    };
    
    return(<section className="Main_section">
        <div className="MainHeader">
            <ul className="MainHeader_Tab">
                <li className={OrderSynceTab === "erp_api_error" ? "active" : ""} onClick={() => Dispatch(getErpOrderSyncTab("erp_api_error"))}>Sales Order</li>
                <li className={OrderSynceTab === "delivery_note_frame_number" ? "active" : ""} onClick={() => Dispatch(getErpOrderSyncTab("delivery_note_frame_number"))}>Delivery Note</li>
                <li className={OrderSynceTab === "erp_invoice_error" ? "active" : ""} onClick={() => Dispatch(getErpOrderSyncTab("erp_invoice_error"))}>Sales Invoice</li>
                <li className={OrderSynceTab === "purchase_order" ? "active" : ""} onClick={() => Dispatch(getErpOrderSyncTab("purchase_order"))}>Purchase Order</li>
                <li className={OrderSynceTab === "purchase_receipt" ? "active" : ""} onClick={() => Dispatch(getErpOrderSyncTab("purchase_receipt"))}>Purchase Receipt</li>
                <li className={OrderSynceTab === "material_transfer" ? "active" : ""} onClick={() => Dispatch(getErpOrderSyncTab("material_transfer"))}>Material Transfer</li>
                <li className={OrderSynceTab === "cancel_order" ? "active" : ""} onClick={() => Dispatch(getErpOrderSyncTab("cancel_order"))}>Cancel Order</li>
            </ul>
        </div>
        <div className="tabletabs_scrolbar">
            {OrderSynceTab === "erp_api_error" ? (
                <ErpApiError 
                    setLoader={setLoader} 
                    OrderViewerModal={OrderViewerModal} 
                    setOrderViewerModal={setOrderViewerModal} 
                />
            ) : OrderSynceTab === "erp_invoice_error" ? (
                <ErpInvoiceList 
                    setLoader={setLoader} 
                    OrderViewerModal={OrderViewerModal} 
                    setOrderViewerModal={setOrderViewerModal} 
                />
            ) : OrderSynceTab === "delivery_note_frame_number" ? (
                <DeliveryNoteFrameNumber 
                    setLoader={setLoader} 
                    OrderViewerModal={OrderViewerModal} 
                    setOrderViewerModal={setOrderViewerModal} 
                />
            ) : OrderSynceTab === "purchase_order" ? (
                <PurchaseOrderTab 
                    setLoader={setLoader} 
                    OrderViewerModal={OrderViewerModal} 
                    setOrderViewerModal={setOrderViewerModal} 
                />
            ) : OrderSynceTab === "purchase_receipt" ? (
                <PurchaseReceiptTab 
                    setLoader={setLoader} 
                    OrderViewerModal={OrderViewerModal} 
                    setOrderViewerModal={setOrderViewerModal} 
                />
            ) : OrderSynceTab === "material_transfer" ? (<MaterialTransferTab 
                    setLoader={setLoader} 
                    OrderViewerModal={OrderViewerModal} 
                    setOrderViewerModal={setOrderViewerModal} 
            />) : (<ErpCancelOrderTab 
                setLoader={setLoader} 
                OrderViewerModal={OrderViewerModal} 
                setOrderViewerModal={setOrderViewerModal} 
            />)}
        </div>
        {OrderViewerModal?.open && (
            <Modal show={OrderViewerModal?.open} className="errorDetailsModal" onHide={()=> CloseErrorMessageModal()}>
                <Modal.Header closeButton>
                <Modal.Title>{OrderViewerModal?.Title}</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{overflow: "auto"}}>
                    <p>
                        {OrderViewerModal?.Data?.response === undefined ? "No Error Found" : OrderViewerModal?.Data?.response}
                    </p>
                </Modal.Body>
            </Modal>
        )}

        {Loader && (<CommonLoader />)}
    </section>)
}

export default ERTApiFailures;